import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Row, SmartTooltip } from '~/commonComponents';
import InfoIcon from '~/images/icons/Info';

export const Title = () => (
  <Row>
    <Typography as="span" bold size="body_large">
      Invite:&nbsp;
      <Typography as="span" color={colors.neutral[500]}>(Optional)</Typography>
    </Typography>
    <SmartTooltip
      content="Please note, invites will not be delivered to candidates on requested dates in which they are unavailable."
      position="bottom"
    >
      <InfoIcon color={colors.neutral[300]} />
    </SmartTooltip>
  </Row>
);
